<template>
  <div class="table-page-search-wrapper" id="table-page-search-wrapper">
    <a-form layout="inline">
      <a-row :gutter="48" class="searchRow">
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="设备编号/设备名称/内部编码/使用人/WBS" v-model="searchModel.fuzzyQueryConditions" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-select
            v-model="searchModel.equipmentStatus"
            :allowClear="true"
            placeholder="设备状态">
            <a-select-option v-for="(item, index) in equipmentStatusList" :key="index" :value="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-tree-select
            v-model="searchModel.usedeptid"
            style="width: 100%"
            placeholder="使用部门"
            allow-clear
            show-search
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :treeData="useDepartmentsList"
            treeNodeFilterProp="title"
            :replaceFields="{
              title: 'url',
              key: 'key',
              value: 'key'
            }"
          ></a-tree-select>
        </a-col>
        <a-col :md="12" :sm="24" class="searchColBtn">
          <span class="table-page-search-submitButtons">
            <a-button class="btn" type="primary" @click="search('search')">查询</a-button>
            <a-button class="btn btnMarginLeft_12" @click="clearSearch">重置</a-button>
            <span class="btnMarginLeft_12 unfoldText" @click="toggleAdvanced">
              <span v-if="advanced">收缩</span>
              <span v-else>展开</span>
              <span v-if="advanced" unselectable="on" class="ant-select-open ant-select-focused ant-select-arrow unfoldIcon" style="user-select: none;"><i aria-label="图标: down" class="anticon anticon-down ant-select-arrow-icon"><svg
                viewBox="64 64 896 896"
                data-icon="down"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                class=""><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></i></span>
              <span v-else unselectable="on" class="ant-select-arrow unfoldIcon" style="user-select: none;"><i aria-label="图标: down" class="anticon anticon-down ant-select-arrow-icon"><svg
                viewBox="64 64 896 896"
                data-icon="down"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
                class=""><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></i></span>
            </span>
          </span>
          <span class="table-page-search-submitButtons">
<!--            <process-drop-down title="发起流程" :process="processList" :popover-style="popoverStyle" @initiateTheProcess="initiateTheProcess"></process-drop-down>-->
          </span>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="searchRow" style="margin-bottom: 10px !important;">
        <a-col :md="4" :sm="24" class="searchColSelect">
          <a-input placeholder="设备编号" v-model="searchModel.equipmentNumber" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColSelect">
          <a-input placeholder="设备名称" v-model="searchModel.name" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-range-picker
            :placeholder="['出库日期开始', '出库日期结束']"
            :showToday="false"
            format="YYYY-MM-DD"
            v-model="searchModel.outboundDelivery"
            style="width: 100%"
          />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColSelect">
          <a-input placeholder="使用人员" v-model="searchModel.principalName" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColSelect">
          <a-input placeholder="资产编号" v-model="searchModel.assetNumber" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-select
            :allowClear="true"
            v-model="searchModel.relevantdeptid"
            showSearch
            optionFilterProp="label"
            placeholder="归口部门"
          >
            <a-select-option v-for="(item, index) in focalDepartmentsList" :value="item.deptId" :label="item.departmentname" :key="index">
              {{ item.departmentname }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="48" class="searchRow" style="margin-bottom: 10px !important;">
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-date-picker
            :showToday="false"
            format="YYYY-MM-DD"
            placeholder="资本化日期"
            v-model="searchModel.capitalizationDate"
          />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="WBS号" v-model="searchModel.wbsNumber" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="项目编号" v-model="searchModel.projectNumber" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="合同编号" v-model="searchModel.contractNumber" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchColInput">
          <a-input placeholder="备注" v-model="searchModel.remark" />
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import processIcon from '@/views/centralizedManagement/modules/processIcon'
import {
  assetTypeList,
  getDeptTreeListInSearch,
  getfocalDepartmentsList,
  getSelectDataList,
  getTreeByRoleUsedeptList
} from '@/api/assetLedger'
import processDropDown from '@/components/ProcessDropDown/ProcessDropDown'
import { delEquipment, getDictList } from '@/api/equipmentLedger'
import { mapGetters } from 'vuex'
export default {
  name: 'SearchForm',
  props: {
    selectedRows: {
      type: Array,
      required: true
    }
  },
  components: {
    processDropDown,
    processIcon
  },
  computed: {
    ...mapGetters(['specialEquipmentSubCompanyId']),
  },
  watch: {
    specialEquipmentSubCompanyId (newValue) {
      if (newValue.id !== '') {
        if (newValue.id === '空') {
          this.useDepartmentsList = []
        } else {
          this.companyId = newValue.id
        }
      } else {
        this.companyId = null
      }
      if (newValue.id !== '空') {
        this.getUseDepartmentsList()
      }
    }
  },
  data () {
    return {
      btnLoading: false,
      showExpend: false,
      searchModel: {},
      popoverStyle: {
        maxWidth: '100px',
        mixWidth: '0px',
        width: '100px'
      },
      processList: ['到货入库', '归还入库', '领用申请', '拨交申请', '调拨申请', '报废申请', '维修申请'],
      advanced: false, // 是否展开
      // 资产状态下拉列表
      assetTypeList: [],
      // 增加方式
      addTypeList: [],
      // 使用方式
      useTypeList: [],
      // 使用部门
      useDepartmentsList: [],
      // 归口部门
      focalDepartmentsList: [],
      // 设备状态列表
      equipmentStatusList: [],
      roleList: [],
      // 是否显示发起流程
      visible: false,
      companyId: null
    }
  },
  created () {
    // 获取资产状态
    this.getAssetTypeList()
    // 获取增加方式，使用状态，归口部门下拉数据
    this.getSelectDataList()
    // 获取归口部门下拉数据
    this.getFocalDepartmentsList()
    // 设备状态
    this.getEquipmentStatusList()
    // 获取使用部门
    // this.getUseDepartmentsList()
  },
  mounted () {
  },
  methods: {
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = self.resetTheChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取资产状态
    getAssetTypeList () {
      assetTypeList().then(res => {
        if (res.status === 0) {
          this.assetTypeList = res.data
        }
      })
    },
    // 获取使用部门
    getUseDepartmentsList () {
      const data = {
        paging: false
      }
      if (this.companyId) {
        data.companyId = this.companyId
      }
      getTreeByRoleUsedeptList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.useDepartmentsList = res.data
        }
      })
    },
    // 搜索使用部门
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 获取增加方式，使用状态下拉数据
    getSelectDataList () {
      getSelectDataList().then(res => {
        if (res.status === 0) {
          this.addTypeList = res.data.tjfsList
          this.useTypeList = res.data.syztList
        }
      })
    },
    // 获取归口部门下拉数据
    getFocalDepartmentsList () {
      getfocalDepartmentsList().then(res => {
        if (res.status === 0) {
          this.focalDepartmentsList = res.data
        }
      })
    },
    // 获取设备状态列表
    getEquipmentStatusList () {
      const data = {
        pCode: 'sb_sbzt'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.equipmentStatusList = res.data
        }
      })
    },
    // 搜索框展开
    toggleAdvanced () {
      const dom = document.getElementById('table-page-search-wrapper')
      if (this.advanced) {
        this.$emit('saveAdvanced', false)
        dom.classList.remove('unfold')
        this.$emit('changeScrollY', 90, 'subtract')
        this.advanced = false
      } else {
        this.$emit('saveAdvanced', true)
        dom.classList.add('unfold')
        this.$emit('changeScrollY', 178, 'addAssetTableHeigth')
        this.advanced = true
      }
    },
    // 点击发起流程
    initiateTheProcess (name) {
      console.log(name)
    },
    // 新增/编辑
    openDrawer (type) {
      this.$emit('openDrawer', type)
    },
    // 导入
    handleImport () {
      this.$emit('handleImport')
    },
    // 导出
    derive (type) {
      this.$emit('derive', type)
    },
    // 删除
    del () {
      if (this.selectedRows.length > 0) {
        const ids = []
        this.selectedRows.forEach(item => {
          ids.push(item.id)
        })
        const data = {
          ids: ids.join(',')
        }
        this.btnLoading = true
        delEquipment(data).then(res => {
          if (res.status === 0) {
            this.$message.success('删除成功！')
            this.search('search')
            this.btnLoading = false
          } else {
            this.$message.error(res.info.msg)
            this.btnLoading = false
          }
        })
      } else {
        this.$message.error('请选择要删除的数据！')
      }
    },
    // 点击查询按钮
    search (type) {
      const model = { ...this.searchModel }
      if (model.fuzzyQueryConditions) {
        model.fuzzyQueryConditions = model.fuzzyQueryConditions.trim()
      }
      // 设备编号
      if (model.equipmentNumber) {
        model.equipmentNumber = model.equipmentNumber.trim()
      }
      // 设备名称
      if (model.name) {
        model.name = model.name.trim()
      }
      // 资产编号
      if (model.assetNumber) {
        model.assetNumber = model.assetNumber.trim()
      }
      // 使用人员
      if (model.principalName) {
        model.principalName = model.principalName.trim()
      }
      // WBS号
      if (model.wbsNumber) {
        model.wbsNumber = model.wbsNumber.trim()
      }
      // 项目编号
      if (model.projectNumber) {
        model.projectNumber = model.projectNumber.trim()
      }
      // 合同编号
      if (model.contractNumber) {
        model.contractNumber = model.contractNumber.trim()
      }
      // 备注
      if (model.remark) {
        model.remark = model.remark.trim()
      }
      if (model.kanswEnd) {
        model.kanswEnd = model.kanswEnd.trim()
      }
      // 资本化日期
      if (model.capitalizationDate) {
        model.capitalizationDate = model.capitalizationDate.format('YYYY-MM-DD 00:00:00')
      }
      // 出库日期开始/结束
      if (model.outboundDelivery) {
        model.outboundDeliveryDate = model.outboundDelivery[0].format('YYYY-MM-DD 00:00:00')
        model.outboundDeliveryDateEnd = model.outboundDelivery[1].format('YYYY-MM-DD 00:00:00')
        delete model.outboundDelivery
      }
      // 使用部门
      if (model.usedeptid) {
        model.usedeptid = Number(model.usedeptid.slice(0, model.usedeptid.indexOf('_')))
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      if (type === 'search') {
        this.$emit('setSearchCondition', model)
      } else {
        this.$emit('derive', model)
      }
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}
      this.$emit('clearSearch', this.searchModel)
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  height: 42px;
  overflow: hidden;
  transition: height 300ms ease;
}
.unfold{
  height: 126px;
  //margin-bottom: 10px;
}
.searchRow {
  margin: 0 !important;
  .ant-calendar-picker {
    width: 100%;
  }
}
.searchColInput {
  padding: 0 12px 0 0 !important;
}
.searchColSelect {
  padding: 0 12px 0 0 !important;
}
.searchColBtn {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .table-page-search-submitButtons {
    margin-bottom: 10px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.btn {
  padding: 0 10px !important;
}
.btnMarginLeft_12 {
  margin-left: 10px !important;
}
.btnLoading {
  padding: 0 10px 0 29px !important;
}
.unfoldText {
  color: #1791FF;
  position: relative;
  cursor: pointer;
  width: 48px;
  display: inline-block;
}
.unfoldIcon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 3px;
  right: 4px;
  margin: auto;
  color: #1791FF;
  font-size: 12px;
  line-height: 1;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
/deep/.ant-popover-title {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
